export function acceptWearSearchSelection({
  fragrance,
  searchInput,
  onResultSelected,
  onCollapseResults,
  onOpenConfirmation,
  onClearPressed,
}) {
  if (!fragrance) return false

  // Record the accepted row before opening confirmation. The confirmation's
  // visibility hook owns confirm_shown, so this transition never duplicates it.
  onResultSelected?.(fragrance)
  searchInput?.blur?.()
  onCollapseResults?.()
  onClearPressed?.()
  onOpenConfirmation?.(fragrance)
  return true
}
